import { render, staticRenderFns } from "./SignupMini.pug?vue&type=template&id=5d810af6&lang=pug&external"
import script from "./SignupMini.js?vue&type=script&lang=js&external"
export * from "./SignupMini.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports